import * as React from "react";

import ChecklistIcon from "@mui/icons-material/Checklist";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { Form, useLoaderData, useNavigate, useParams } from "react-router-dom";
import { Result } from "../../types/Result";
import MuAutocomplete from "../components/autocomplete/MuiAutocomplete";
import MuiDatePicker from "../components/MuiDatePicker";
import { AssignmentPeriod } from "./type";

export default function AssignmentPeriodForm() {
  const params = useParams();
  const navigate = useNavigate();
  const data = useLoaderData() as Result<AssignmentPeriod>;
  const years = React.useMemo(() => {
    const now = new Date().getFullYear();
    const arrays: number[] = [];
    for (let index = now - 4; index < now + 5; index++) {
      arrays.push(index);
    }
    return arrays;
  }, []);
  const [selectedYear, setSelectedYear] = React.useState(
    data.data?.year || years[0]
  );
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "800px" } }}>
      <Form method="post">
        <TextField
          placeholder="Kod"
          type="text"
          name="assignmentPeriodCode"
          defaultValue={data.data?.assignmentPeriodCode}
          fullWidth
          margin="dense"
          label="Kod"
          disabled
        />
        <MuAutocomplete
          margin="dense"
          disabled={!!data.data?.assignmentPeriodCode}
          defaultValue={data.data?.professionCode}
          name="professionCode"
          url="/api/professions"
          dataItemKey="professionCode"
          dataTextValue="name"
          label="Branş"
          required
        />
        {!data.data?.assignmentPeriodCode ? (
          <FormControl fullWidth required>
            <InputLabel id="year">Yıl</InputLabel>
            <Select
              name="year"
              labelId="year"
              label="Yıl"
              required
              value={selectedYear}
              type="number"
              onChange={(e) => setSelectedYear(+e.target.value)}
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <TextField
            placeholder="Yıl"
            type="number"
            name="year"
            defaultValue={data.data?.year}
            fullWidth
            margin="dense"
            label="Yıl"
            required
            disabled
          />
        )}
        <TextField
          placeholder="Dönem"
          type="number"
          name="period"
          defaultValue={data.data?.period}
          fullWidth
          margin="dense"
          label="Dönem"
          required
          disabled={!!data.data?.assignmentPeriodCode}
        />
        {!!data.data?.assignmentPeriodCode && (
          <input name="period" value={data.data?.period} type="hidden" />
        )}
        {!!data.data?.assignmentPeriodCode && (
          <input name="year" value={data.data?.year} type="hidden" />
        )}
        {!!data.data?.assignmentPeriodCode && (
          <input
            name="professionCode"
            value={data.data?.professionCode}
            type="hidden"
          />
        )}
        <MuiDatePicker
          defaultValue={dayjs(data.data?.startDate)}
          name="startDate"
          label="Başlangıç Tarihi"
          sx={{ width: "100%", my: 1 }}
          slotProps={{ textField: { required: true } }}
        />
        <MuiDatePicker
          defaultValue={dayjs(data.data?.endDate)}
          name="endDate"
          label="Bitiş Tarihi"
          sx={{ width: "100%", my: 1 }}
          slotProps={{ textField: { required: true } }}
        />
        {!!data.data?.assignmentPeriodCode && (
          <FormControlLabel
            name="isActive"
            control={<Checkbox defaultChecked={data.data?.isActive} />}
            label="Aktif"
          />
        )}
        <TextField
          placeholder="Tanım"
          type="text"
          name="description"
          defaultValue={data.data?.description}
          fullWidth
          margin="dense"
          label="Tanım"
          rows={4}
          multiline
        />
        <FormControlLabel
          name="isEarlyStagePremium"
          control={<Checkbox defaultChecked={data.data?.isEarlyStagePremium} />}
          label="Erken Dönem Premium"
        />
        <Button fullWidth type="submit" variant="contained">
          Kaydet
        </Button>
      </Form>
      {params.assignmentPeriodCode !== "new" && (
        <SpeedDial
          ariaLabel="SpeedDial basic example"
          sx={{ position: "absolute", bottom: 16, right: 16 }}
          icon={<SpeedDialIcon />}
        >
          <SpeedDialAction
            icon={<ChecklistIcon />}
            tooltipTitle={"Tercihler"}
            onClick={() => navigate("preferences")}
          />
        </SpeedDial>
      )}
    </Box>
  );
}
